module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image8c.1b6fe6d2.webp";